export var FieldFormatType;
(function (FieldFormatType) {
    FieldFormatType["Text"] = "Text";
    FieldFormatType["Email"] = "Email";
    FieldFormatType["Number"] = "Number";
    FieldFormatType["Currency"] = "Currency";
    FieldFormatType["Date"] = "Date";
    FieldFormatType["Password"] = "Password";
    FieldFormatType["Other"] = "Other";
})(FieldFormatType || (FieldFormatType = {}));
